import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import { ACTIVE_PROFILE } from '../../../config';

// Data
// import shopriteSSORedirectLink from '../../../assets/js/shopriteSSORedirectLink.json';
import shopriteSignOutButton from '../../../assets/js/shopriteSignOutButton';

class AppInitializer extends Component {

  static propTypes = {
    // Redux
    authToken: PropTypes.string,
    userId: PropTypes.string,
    loyaltyCardNumber: PropTypes.string,
    // Redux Actions

  }

  static defaultProps = {}

  state = {
    isLoggedIn: false
  }

  componentDidMount() {
    const {
      postAllEngagementAnswers,
      setLoading,
    } = this.props;

    setLoading(true);
    this.loginOrRedirect();

    window.addEventListener('beforeunload', () => postAllEngagementAnswers(), false);
  }

  loginOrRedirect() {
    const cardNum = this.getCardNum();
    this.tryToLogin(cardNum);
  }

  getCardNum() {
    const {
      loyaltyCardNumber,
      getLoyaltyCardFromCookies
    } = this.props;
    /*
      Get card number from (in order):
        1. Redux
        2. Cookies
    */
    var cookiesCardNum = String(getLoyaltyCardFromCookies());
    var cardNum = (loyaltyCardNumber && loyaltyCardNumber.length >= 11)
      ? loyaltyCardNumber.slice(0,11)
      : (cookiesCardNum && cookiesCardNum.length >= 11)
      ? cookiesCardNum.slice(0,11)
      : false;

    return cardNum;
  }

  tryToLogin(cardNum) {
    const {
      createNewUserOrSignIn,
      setLoading,
    } = this.props;

    if (cardNum && cardNum.length === 11) {
      return createNewUserOrSignIn(cardNum)
      .then((isNewUser) => {
        if (isNewUser === true) {
          this.props.history.push('/tutorial');
        } else if (!this.props.isAuthenticated)
          this.redirectToLogin();
      })
      .then(() => this.onSuccessfulLogin())
      .catch((err) => {
        setLoading(false);
        console.log('AppInitializer - Error trying to log in.');
        console.log(err);
      });
    }

    else this.redirectToLogin();
  }

    onSuccessfulLogin() {
        const {
            getCampaigns,
            getCardBalance,
            setLoading,
        } = this.props;
        return Promise.all([getCampaigns(), getCardBalance()])
            .then(() => shopriteSignOutButton()) // change shoprites sign out button
            // .then(() => this.startMixPanel())
            .then(() => setLoading(false))
            .then(() => this.setState({isLoggedIn: true}))
            .catch(err => {
                setLoading(false);
                console.log(err);
            });
    }

  redirectToLogin() {
    const { history } = this.props;
    if (ACTIVE_PROFILE === 'prod' || ACTIVE_PROFILE === 'production' || ACTIVE_PROFILE === 'stage')
      history.push('/saml');
    else history.push('/login');
  }

  startMixPanel() {
    const {
      userId,
      loyaltyCardNumber,
      registerSuperProps,
      startSession,
    } = this.props;

    // Must register super props first; perform synchronously
    return Promise.resolve()
      .then(() => registerSuperProps({
        userId: userId,
        loyaltyId: loyaltyCardNumber
      }))
      .then(() => startSession(loyaltyCardNumber))
      // .then(() => mixpanelOnBeforeCloseHandler())
      // .then(() => mixpanelPageVisibilitySessionDurationTimer())
      .catch(err => {
        console.log('AppInitializer - Failed to start mixpanel.');
        console.log(err);
      });
  }

  render() {
    const { isLoggedIn } = this.state;
    const { match } = this.props;

    if (!isLoggedIn)
      return <div></div>;

    else
      return (
        <div>
          {React.Children.map(this.props.children,
            child => React.cloneElement(child, { match: match })
          )}
        </div>
      );
  }
}

export default AppInitializer;



// WEBPACK FOOTER //
// ./src/HOC/withAppInitilizationChecks/AppInitializer/AppInitializer.js